const MADAME = 'MME';
const MONSIEUR = 'M';

const PARTICULIER = 'PART';
const PROFESSIONNEL_RECEPTION = 'PRO';
const SYNDIC_BAILLEUR = 'GEST_SYNDIC';
const ELU = 'ELU';
const JOURNALISTE = 'PRO_JOURNALISTE';
const AUTRE = 'AUTRE';

const CIVILITE = {
  MADAME: MADAME,
  MONSIEUR: MONSIEUR,

  VALUES: [
    MADAME,
    MONSIEUR,
  ],
  DEFAULT_VALUE: MADAME
};

const TYPE_PERSONNE = {
  PARTICULIER: PARTICULIER,
  PROFESSIONNEL_RECEPTION: PROFESSIONNEL_RECEPTION,
  SYNDIC_BAILLEUR: SYNDIC_BAILLEUR,
  ELU: ELU,
  JOURNALISTE: JOURNALISTE,
  AUTRE: AUTRE,

  VALUES: [
    PARTICULIER,
    PROFESSIONNEL_RECEPTION,
    SYNDIC_BAILLEUR,
    ELU,
    JOURNALISTE,
    AUTRE
  ]
};

export { CIVILITE, TYPE_PERSONNE };



// WEBPACK FOOTER //
// ./src/modules/base/model.js